import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=10f285ac&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10f285ac')) {
      api.createRecord('10f285ac', component.options)
    } else {
      api.reload('10f285ac', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=10f285ac&", function () {
      api.rerender('10f285ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/mantap/components/Table.vue"
export default component.exports